const banner = document.getElementById('popup-banner');
if (banner) {
  const STORAGE_KEY = 'popup_closed_at';
  const THIRTY_MINUTES = 30 * 60 * 1000;

  // 除外する商品ページ
  const excludedProducts = [
    '/products/shinn-sumi-リフレッシュミスト01-ボディミストローション-100ml'
  ];

  // 表示させるパスのホワイトリスト
  const allowedPaths = [
    /^\/$/, // トップ
    /^\/collections\//, // コレクション
    /^\/products\//, // 商品詳細
    /^\/pages\/about$/, // aboutページ
    /^\/blogs\//, // ブログ全般
    /^\/pages\/contact$/, // contactページ
  ];

  const currentPath = decodeURIComponent(window.location.pathname);
  const isExcludedProduct = excludedProducts.some(path => currentPath.startsWith(path));
  const isAllowed = !isExcludedProduct && allowedPaths.some(pattern => pattern.test(currentPath));

  if (!isAllowed) {
    // 表示対象外のページは何もしない
  } else {
    const closedAt = localStorage.getItem(STORAGE_KEY);
    if (closedAt && Date.now() - parseInt(closedAt) < THIRTY_MINUTES) {
      banner.classList.add('is-hidden');
    } else {
      let shown = false;

      const showBanner = () => {
        if (shown) return;
        shown = true;
        banner.classList.add('is-visible');
      };

      const timer = setTimeout(showBanner, 4000);

      window.addEventListener('scroll', () => {
        if (window.scrollY >= window.innerHeight) {
          clearTimeout(timer);
          showBanner();
        }
      });

      banner.querySelector('.popup-banner__close').addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
        banner.classList.add('is-hidden');
      });
    }
  }
}